import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "data-structure"
    }}>{`Data Structure`}</h1>
    <p>{`In our product we have used three document/table`}</p>
    <ol>
      <li parentName="ol">{`posts`}</li>
      <li parentName="ol">{`category`}</li>
      <li parentName="ol">{`users`}</li>
    </ol>
    <h3 {...{
      "id": "posts"
    }}>{`Posts`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
    id: ID
    title: String
    slug: String
    content: String
    status: String
    author: Author
    authorId: ID
    image: Image
    price: Float
    location: Location
    formattedLocation: Location
    distance: Float
    categories: [Category]
    gallery: [Image]
    isNegotiable: Boolean
    favouritedBy: [String]
    condition: Boolean
    related(limit: Int): [Post]
    contactNumber: String
    createdAt: Date
    updatedAt: Date
}
`}</code></pre>
    <h3 {...{
      "id": "category"
    }}>{`Category`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
   id: ID!
   slug: String
   name: String
   value: ID
   label: String
   image: Image
   posts(limit: Int, page: Int ): PostWithCount
   createdAt: Date
   updatedAt: Date
}
`}</code></pre>
    <h3 {...{
      "id": "users"
    }}>{`Users`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
   id: ID
   email: String
   username: String
   mobile: [Mobile]
   image: Image
   address: String
   website: String
   name: String
   posts(limit: Int, page: Int): PostWithCount
   favourite(limit: Int, page: Int): PostWithCount
   draft(limit: Int, page: Int) : PostWithCount
   createdAt: Date
   updatedAt: Date
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      